var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-row",
    { attrs: { align: "baseline" } },
    [
      _c(
        "v-col",
        [
          _c("v-select", {
            attrs: {
              items: _vm.sources,
              label: _vm.label,
              hint: _vm.hint,
              "persistent-hint": _vm.hint ? true : false,
            },
            on: {
              change: function ($event) {
                return _vm.$emit("change")
              },
            },
            model: {
              value: _vm.computedValue.type,
              callback: function ($$v) {
                _vm.$set(_vm.computedValue, "type", $$v)
              },
              expression: "computedValue.type",
            },
          }),
          _vm.value.type === "Market"
            ? _c("InputPriceMarket", {
                attrs: {
                  num_years: _vm.num_years,
                  "allowed-schedules": _vm.schedules,
                },
                on: {
                  change: function ($event) {
                    return _vm.$emit("change")
                  },
                },
                model: {
                  value: _vm.computedValue.market,
                  callback: function ($$v) {
                    _vm.$set(_vm.computedValue, "market", $$v)
                  },
                  expression: "computedValue.market",
                },
              })
            : _vm._e(),
          _vm.value.type === "Custom"
            ? [
                _vm.multiYear
                  ? _c(
                      "v-row",
                      [
                        _c(
                          "v-col",
                          [
                            _c("v-text-field", {
                              attrs: { label: "Start Year", type: "number" },
                              on: {
                                change: function ($event) {
                                  return _vm.$emit("change")
                                },
                              },
                              model: {
                                value: _vm.computedValue.year_start,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.computedValue,
                                    "year_start",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "computedValue.year_start",
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-col",
                          [
                            _c("v-text-field", {
                              attrs: { label: "End Year", type: "number" },
                              on: {
                                change: function ($event) {
                                  return _vm.$emit("change")
                                },
                              },
                              model: {
                                value: _vm.computedValue.year_end,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.computedValue,
                                    "year_end",
                                    _vm._n($$v)
                                  )
                                },
                                expression: "computedValue.year_end",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _c("v-select", {
                  attrs: { items: _vm.schedules, label: "Index Type" },
                  on: {
                    change: function ($event) {
                      return _vm.$emit("change")
                    },
                  },
                  model: {
                    value: _vm.computedValue.index,
                    callback: function ($$v) {
                      _vm.$set(_vm.computedValue, "index", $$v)
                    },
                    expression: "computedValue.index",
                  },
                }),
                _c("InputPriceCustom", {
                  attrs: { reserves: _vm.reserves },
                  on: {
                    change: function ($event) {
                      return _vm.$emit("change")
                    },
                  },
                  model: {
                    value: _vm.computedValue.nodes,
                    callback: function ($$v) {
                      _vm.$set(_vm.computedValue, "nodes", $$v)
                    },
                    expression: "computedValue.nodes",
                  },
                }),
              ]
            : _vm._e(),
        ],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }